<template>
  <div v-if="$store.getters.retrieveAdmin">
    <v-row class="pt-0" align="start">
      <v-col cols="12" class="pb-0">
        <v-banner icon="mdi-account-circle-outline"> Your Account </v-banner>
      </v-col>
      <v-col cols="12" :md="getVal">
        <v-banner icon="account_box">User Information</v-banner>

        <v-row class="pt-0" align="start">
          <v-col cols="12" class="pb-0">
            <v-card flat color="background">
              <UserInfo />
            </v-card>
          </v-col>

          <v-col cols="12" mx="1" md="6" class="pb-0">
            <v-btn
              text
              dark
              color="blue darken-2"
              :to="{ name: 'ChangeUserDetails' }"
            >
              <v-icon class="mr-2">edit</v-icon>Edit User Info
            </v-btn>
          </v-col>

          <v-col cols="12" mx="1" md="6" class="pb-0">
            <v-btn
              text
              dark
              color="blue darken-2"
              :to="{ name: 'ChangePassword' }"
            >
              <v-icon class="mr-2">lock</v-icon>Change Password
            </v-btn>
          </v-col>

          <v-col cols="12" mx="1" md="6" class="pb-0">
            <v-btn
              text
              color="blue darken-2"
              :loading="loadingSurvey"
              @click="getSurvey()"
            >
              <v-icon class="mr-2">mdi-message-text</v-icon>Communication
              Preferences
            </v-btn>
          </v-col>

          <v-col cols="12" mx="1" md="6" class="pb-0">
            <v-dialog v-model="confirmDeleteDialog" max-width="500">
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  color="error"
                  @click.stop="confirmDeleteDialog = true"
                >
                  <v-icon class="mr-2">delete_forever</v-icon>Delete User
                  Account
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="justify-center">
                  Delete User Account
                  <v-spacer />
                  <v-btn icon @click.stop="confirmDeleteDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <span class="body-2 mt-3"
                    >Are you sure you want to delete your account?</span
                  >
                  <span> This action cannot be undone</span>
                </v-card-text>
                <v-card-actions class="mt-3 dialogActions">
                  <v-btn text @click.stop="confirmDeleteDialog = false"
                    >Close</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn color="error" outlined @click.stop="deleteAccount"
                    >Delete</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        v-if="
          $store.getters.retrieveAdmin.account_type == 'C1' && isAccountCustomer
        "
      >
        <v-banner icon="badge">Customer Information</v-banner>
        <CustomerAddress />
      </v-col>

      <v-col cols="12" v-else>
        <DeliveryAddresses :showBack="false" />
      </v-col>

      <v-col cols="12" v-if="showCardManager">
        <SavedCardsSetting />
      </v-col>
      <v-col cols="12">
        <CustomerDeliveryDays />
      </v-col>
    </v-row>
    <!------Saved Cards Section-------->

    <v-row justify="center">
      <v-dialog v-model="showDialog" persistent max-width="600px">
        <GDPR
          :getSurveyData="getSurveyData"
          :forceShow="true"
          @close-dialog="showDialog = false"
        ></GDPR>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import GDPR from "@/components/account/GDPR.vue";
import CustomerDeliveryDays from "@/components/account/CustomerDeliveryDays.vue";
import CustomerAddress from "@/components/customer/CustomerAddress.vue";
import UserInfo from "@/components/user/InfoCard.vue";

import SavedCardsSetting from "@/components/payment/ManageSavedCards.vue";

import DeliveryAddresses from "@/components/deliveryAddresses/UserAddresses.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "Account",
  components: {
    GDPR,
    UserInfo,
    CustomerAddress,
    CustomerDeliveryDays,
    SavedCardsSetting,
    DeliveryAddresses,
  },
  data: () => ({
    loadingSurvey: false,
    showDialog: false,
    getSurveyData: {},
    confirmDeleteDialog: false,
  }),
  computed: {
    ...mapGetters([
      "retrieveUser",
      "retrieveIsCashCustomer",
      "retrieveIsCncCustomer",
      "retrieveShowMenuDrawer",
      "retrieveCustomerAddress",
      "retrieveCustomer",
    ]),
    showHideCheck() {
      if (this.retrieveShowMenuDrawer) {
        return true;
      }
      return false;
    },
    showCardManager() {
      if (!this.retrieveIsCncCustomer && !this.retrieveIsCashCustomer && this.retrieveUser.account_type != "A1") {
        return true;
      }
      return false;
    },
    getVal() {
      if (this.showCardManager) {
        return "12";
      }
      return "12";
    },

    isAccountCustomer() {
      if (this.retrieveCustomer !== 'no_customers') {
        if (
          this.retrieveCustomer.customer.delivery_account_no == "3" ||
          this.retrieveCustomer.customer.delivery_account_no == "1"
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      "deleteUserAccount",
      "setSnackbar",
      "getSavedPaymentMethods",
      "removeSourceAction",
      "setDefaultSourceAction",
    ]),
    async getSurvey() {
      this.showDialog = true;
      this.loadingSurvey = true;

      console.log(" -- Get Survey");
      let stringPayload = JSON.stringify({
        userId: this.retrieveUser.userNum,
        sessionKey: this.retrieveUser.sessionKey,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("get-survey", params)
        .then((response) => {
          if (response.data.success == true) {
            this.getSurveyData = response.data;
            return response.data.success;
          } else {
            return response.data.success;
          }
        })
        .catch((e) => {
          console.log(e);
          return false;
        });

      this.loadingSurvey = false;
      this.showDialog = true;
    },

    deleteAccount() {
      this.confirmDeleteDialog = false;
      const rec = Object.assign(
        {},
        { userId: this.retrieveUser.userNum },
        { sessionKey: this.retrieveUser.sessionKey }
      );
      this.deleteUserAccount(rec)
        .then((response) => {
          if (response.success == true) {
            //clear all user data in store
            this.setSnackbar({
              text: "Your account has been deleted successfully",
            });
            this.$router.push({ name: "SignIn" });
            this.$store.dispatch("userSignoutAction");
          } else {
            this.setSnackbar({ color: "error", text: response.message });
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>